import { apiClient } from './api';

type Pagination = {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

export type SupplierListItem = {
  id: string | number;
  name: string;
  vineyards: string | number;
  bulkWine: string | number;
  cleanskins: string | number;
  fruits: string | number;
  users: string | number;
  dateCreated: string;
};

export type SuppliersListResponse = {
  data: SupplierListItem[];
  pagination: Pagination;
};

export type SupplierFilterOptionsResponse = {
  regions: Array<{ id: number; name: string; countryId: number }>;
  countries: Array<{ id: number; name: string }>;
};

export const suppliersService = {
  getList: (params: URLSearchParams) =>
    apiClient.get<SuppliersListResponse>(`/suppliers?${params.toString()}`),

  getById: (id: string | number) => apiClient.get<any>(`/suppliers/${id}`),

  save: (id: string | number | null, payload: Record<string, unknown>) =>
    id
      ? apiClient.put<any, Record<string, unknown>>(`/suppliers/${id}`, payload)
      : apiClient.post<any, Record<string, unknown>>('/suppliers', payload),

  remove: (id: string | number) =>
    apiClient.delete<{ id: number; message: string }>(`/suppliers/${id}`),

  getFilterOptions: () =>
    apiClient.get<SupplierFilterOptionsResponse>('/suppliers/filter-options/regions-countries'),
};
